module.exports = __webpack_public_path__ + "assets/8fcb4ebcc22f16fa88fbf4c1c43ee869.ttf";